query getSavedDesignSources($id: ID!) {
  savedDesignById(id: $id) {
    backgroundMaskImageUrl
    colorisationImageUrl
    enhanceFacesImageUrl
    posteriseImage {
      type
      url
      message
    }
    faceBoundingBoxes {
      x
      y
      width
      height
    }
  }
}
